export default "dist/images/block-notification-basic.1163055.png";